"use client"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const PartnersSection = () => {
  const sponsors = [
    {
      id: 1,
      name: "Minister of Transport and Logistics, Ethiopia",
      logo: "/assets/images/MoTL.jpg",
      website: "https://www.motl.gov.et/",
    },
    {
      id: 2,
      name: "Ethiopia Maritime Authority",
      logo: "/assets/images/ema.png",
      website: "https://etmaritime.com/",
    },
    {
      id: 3,
      name: "Ethiopian Airlines",
      logo: "/assets/images/airlinesss.png",
      website: "https://www.ethiopianairlines.com/",
    },
    {
      id: 4,
      name: "Ethiopian Maritime Training Institute",
      logo: "/assets/images/emtisc.jpg",
      website: "https://emticorp.com/",
    },
    {
      id: 5,
      name: "EMA Marine",
      logo: "/assets/images/EMA_logo.png",
      website: "https://www.emacrew.com/",
    },
    {
      id: 6,
      name: "Skylight Hotel and Conference Venue",
      logo: "/assets/images/airlinessss.png",
      website: "https://www.ethiopianskylighthotel.com/",
    },
  ]

  const settings = {
    dots: false,
    infinite: true,
    speed: 10000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  }

  const handleLogoClick = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer")
    }
  }

  const duplicatedSponsors = [...sponsors, ...sponsors]

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-primary-navy mb-4">Our Partners</h2>
          <div className="h-1 w-20 bg-gradient-to-r from-primary-orange to-primary-blue mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We are proud to collaborate with leading organizations that share our vision for maritime excellence in
            Africa.
          </p>
        </div>

        <div className="relative">
          <Slider {...settings} className="partners-slider">
            {duplicatedSponsors.map((sponsor, index) => {
              const isEthiopianAirlines = sponsor.id === 3

              return (
                <div key={`${sponsor.id}-${index}`} className="px-4">
                  <div
                    className="flex items-center justify-center h-32 p-4 group cursor-pointer"
                    onClick={() => handleLogoClick(sponsor.website)}
                    title={`Visit ${sponsor.name}`}
                  >
                    <div
                      className={`p-4 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 w-full h-full flex items-center justify-center ${
                        isEthiopianAirlines
                          ? "bg-gradient-to-br from-blue-50 to-white border-2 border-blue-200 hover:border-blue-400"
                          : "bg-white"
                      }`}
                    >
                      <img
                        src={sponsor.logo || "/placeholder.svg"}
                        alt={sponsor.name}
                        className={`w-auto object-contain transition-all duration-300 ${
                          isEthiopianAirlines
                            ? "h-20 max-w-[180px] opacity-100 hover:scale-110"
                            : "h-16 max-w-[160px] grayscale hover:grayscale-0 opacity-90 hover:opacity-100"
                        }`}
                        style={{
                          cursor: "pointer",
                        }}
                        onError={(e) => {
                          e.target.src = "/placeholder-logo.png"
                        }}
                      />
                      {isEthiopianAirlines && (
                        <div className="absolute -top-2 -right-2 bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-bold shadow-md">
                          ✈️ Official Partner
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </Slider>
        </div>
      </div>
    </section>
  )
}

export default PartnersSection
